import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LoteProduto } from 'src/app/models/lote-produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { LoteProdutoService } from 'src/app/services/lote-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-lotes-do-produto-modal',
  templateUrl: './lotes-do-produto-modal.component.html',
  styleUrls: ['./lotes-do-produto-modal.component.scss']
})
export class LotesDoProdutoModalComponent implements OnInit, OnDestroy {

  // variáveis
  // produtos: Produto[] = [];
  lotes: LoteProduto[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  idFornecedor;
  idProduto;

  constructor(private loteProdutoService: LoteProdutoService, public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private globalService: GlobalService,
    public dialogRef: MatDialogRef<LotesDoProdutoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  async ngOnInit() {
    this.idFornecedor = this.data.idFornecedor;
    this.idProduto = this.data.idProduto;
    this.buscarEstoque();
  }

  buscarEstoque() {
    this.carregandoService.mostra('buscaProdutos');

    this.loteProdutoService.consultarPorIdProduto(this.idProduto, this.idFornecedor).subscribe(dados => {
      this.lotes = dados;      
      this.carregandoService.esconde('buscaProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscaProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }

  
}
